import { actions, actionTypes, selectors } from 'data'
import isNil from 'lodash/isNil'
import { call, put, select, take, takeEvery } from 'redux-saga/effects'

import { getEddStatus } from '../TierTwo/Sagas'
import { DepositActionType } from './actions'

const open = function* (action: DepositActionType) {
  const isHighRisk: boolean = yield select(selectors.auth.isHighRisk)
  if (isHighRisk) {
    yield call(getEddStatus)
    yield take(actionTypes.tierTwo.SUBMIT)
  }

  // Check if 2FA is enabled
  yield put(actions.twoFactor.getStatus())
  yield take(actionTypes.auth.SET_TWO_FACTOR_STATUS)

  const { currency, isVerification, origin } = action.payload

  if (!isNil(isVerification)) {
    yield put(actions.app.showModal('VERIFICATION_DEPOSIT'))
    return
  }

  yield put(actions.app.showModal('DEPOSIT', { currency, origin }))
}

export default function* depositForm() {
  yield takeEvery(actionTypes.deposit.OPEN, open)
}
